import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function Privacy() {
  return (
    <main data-testid="privacy-page" className="min-h-screen bg-white">
      <Header />
      <section className="pt-32 pb-20 max-w-3xl mx-auto px-6 md:px-10">
        <div className="text-[11px] uppercase tracking-[0.3em] text-[#5ab500] font-bold mb-4">
          — Legal
        </div>
        <h1 className="font-heading text-4xl md:text-5xl font-light text-[#1c1f1a]">
          Privacy Policy
        </h1>
        <div className="mt-10 space-y-6 text-[#4a4f47] leading-relaxed">
          <p>
            La presente informativa è resa ai sensi dell'art. 13 del Regolamento
            UE 2016/679 (GDPR) agli utenti che interagiscono con i servizi di
            Minicarmobilità.
          </p>
          <h2 className="font-heading text-xl text-[#1c1f1a] mt-8 font-semibold">
            Titolare del trattamento
          </h2>
          <p>
            Micromobilità Licari S.r.l.s. — Sede fiscale: V. Giuseppe Dezza, 24,
            20144 Milano — P.IVA 14669860968 — PEC: auto.licari@legalmail.it —
            Email: auto.licari26@gmail.com
          </p>
          <h2 className="font-heading text-xl text-[#1c1f1a] mt-8 font-semibold">
            Dati raccolti
          </h2>
          <p>
            Raccogliamo i dati che ci fornisci attraverso il modulo di contatto
            (nome, email, telefono, messaggio) al solo scopo di rispondere alle
            tue richieste sui veicoli in vetrina.
          </p>
          <h2 className="font-heading text-xl text-[#1c1f1a] mt-8 font-semibold">
            Diritti dell'interessato
          </h2>
          <p>
            Hai diritto di accesso, rettifica, cancellazione, limitazione,
            opposizione e portabilità dei tuoi dati personali. Per esercitare
            tali diritti puoi scriverci a auto.licari26@gmail.com.
          </p>
          <p className="text-xs text-[#7a7f77] mt-12">
            Documento di esempio. Da adattare con il proprio consulente legale.
          </p>
        </div>
      </section>
      <Footer />
    </main>
  );
}
